import { Error403Unauthorized } from '@app/components';
import { FORBIDDEN_ERROR_MAIN_PART } from '@app/constants';
import { PF } from '@app/pages/Warehouses/Brands/data';
import {
  useBrands,
  useBrandsEffects,
} from '@app/pages/Warehouses/Brands/hooks';
import { Filters, BrandsTable } from '@app/pages/Warehouses/Brands/ui';
import { FiltersAccordion } from '@app/shared/components';

import '@pages/Warehouses/Brands/styles/Brands.scss';

export const Brands = () => {
  const {
    filters,
    unsavedFilters,
    onPaginate,
    range,
    onPageSizeChange,
    columns,
    total,
    tableData,
    onChangeSearchTerm,
    skipSearchTerm,
    onSearch,
    onSearchHandler,
    isPageLoading,
    isFetching,
    IsBrands,
  } = useBrands();

  useBrandsEffects({ onSearchHandler });

  if (!IsBrands) {
    return <Error403Unauthorized title={FORBIDDEN_ERROR_MAIN_PART} />;
  }

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_filters-section`}>
        <FiltersAccordion>
          <Filters
            values={filters}
            unsavedValues={unsavedFilters}
            onChangeSearchTerm={onChangeSearchTerm}
            skipSearchTerm={skipSearchTerm}
            onSearch={onSearch}
          />
        </FiltersAccordion>
      </div>

      <div className={`${PF}_table-section`}>
        <BrandsTable
          columns={columns}
          data={tableData}
          filters={filters}
          total={total}
          range={range}
          onPaginate={onPaginate}
          onPageSizeChange={onPageSizeChange}
          isPageLoading={isPageLoading}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
};
